import type { SectionHeadingProps } from "../types";

export default function SectionHeading({
  index,
  eyebrow,
  title,
  desc,
  actionHref,
  actionLabel,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 border-b border-background-300/40 pb-5 md:flex-row md:items-end md:justify-between">
      <div className="flex items-start gap-4">
        <span className="font-label mt-1 shrink-0 text-2xl leading-none text-primary-400 md:text-3xl">
          {index}
        </span>
        <div>
          <div className="flex items-center gap-3">
            {eyebrow ? (
              <span className="rounded-full border border-background-300/60 bg-background-100 px-3 py-1 text-xs tracking-wide text-foreground-500">
                {eyebrow}
              </span>
            ) : null}
            <h2 className="font-display text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
          </div>
          {desc ? <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">{desc}</p> : null}
        </div>
      </div>
      {actionHref && actionLabel ? (
        <a
          href={actionHref}
          className="inline-flex w-fit shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300/60 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-300"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </a>
      ) : null}
    </div>
  );
}